module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_5-0c1ab80618cc7bd648090dff93f3b894.jpg";